import { AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface IntentsErrorStateProps {
  onRetry: () => void
}

export function IntentsErrorState({ onRetry }: IntentsErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16" role="alert" data-testid="intents-error">
      <AlertCircle className="h-12 w-12 text-destructive" />
      <h3 className="mt-4 text-lg font-semibold">Failed to load intents</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Something went wrong while loading your intents.
      </p>
      <Button onClick={onRetry} variant="outline" className="mt-4">
        Try Again
      </Button>
    </div>
  )
}
